export default {"src":"/_next/static/media/firefox.1a3e52f9.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};